<template>
  <div class="popUpWrap">
    <section class="popup dark subscription">
      <div class="topArea">
        <div class="exit" @click.stop="dialogStore.close" />
      </div>
      <div class="scrollY">
        <div class="textArea flex">
          <h5>{{ t('organization-subscription-restart-subscription-title') }}</h5>
          <p v-html="convertToNextLine(t('organization-subscription-restart-subscription-description-2'))" />
        </div>
        <div class="boxArea">
          <div class="titleArea">
            <p>{{ t('organization-subscription-restart-subscription-description-1') }}</p>
            <h5>{{ dialogStore.options.props.planName }}</h5>
          </div>
        </div>
        <div class="btnArea">
          <button type="button" class="cancel" @click.stop="dialogStore.close">{{ t('common-cancel') }}</button>
          <button type="button" @click.stop="onClickRestartSubscription">
            {{ t('organization-subscription-restart-subscription') }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import {useDialogStore} from '~/store/dialog/dialogStore';

const {t} = useI18n();
const dialogStore = useDialogStore();

const onClickRestartSubscription = () => {
  dialogStore.close();
  dialogStore.options.confirm?.event()
}
</script>